<template>
  <div>
    <b-overlay variant="light" opacity=".3" blur="2px" :show="show_overlay">
      <b-form @submit="onSubmit">
        <div class="d-flex justify-content-between align-items-center mb-4">
          <h1>{{ user.name }}</h1>
          <div class="d-flex flex-row-reverse">
            <b-button type="submit" size="sm" variant="exitos">Salvar</b-button>
          </div>
        </div>

        <b-row>
          <b-col cols="7">
            <b-card>
              <FormProfile ref="form_profile" />
            </b-card>
          </b-col>
          <b-col cols="5">
            <b-card>
              <ImageProfile v-model="imagem" />

              <hr class="my-3" />

              <FormProfileContatos ref="form_profile_contatos" />

              <hr class="my-3" />

              <FormProfileSenha ref="form_profile_senha" />
            </b-card>
          </b-col>
        </b-row>
      </b-form>
    </b-overlay>
  </div>
</template>

<script>
import FormProfile from "../Components/FormProfile.vue";
import FormProfileContatos from "../Components/FormProfileContatos.vue";
import FormProfileSenha from "../Components/FormProfileSenha.vue";
import ImageProfile from "../Components/ImageProfile.vue";
import { mapState, mapActions } from "vuex";

export default {
  components: {
    FormProfile,
    FormProfileContatos,
    FormProfileSenha,
    ImageProfile,
  },
  data: () => ({
    selectedFile: null,
    imagem: {},
    validations: {
      form_profile: true,
      form_profile_contatos: true,
      form_profile_senha: true,
    },
    show_overlay: false,
  }),
  computed: {
    ...mapState("auth", ["user"]),
    pessoa_fisica() {
      return this.user.pessoa_fisica ? this.user.pessoa_fisica : {};
    },
  },
  methods: {
    ...mapActions("users", ["ActionNewUser", "ActionSaveProfile"]),
    ...mapActions("auth", ["ActionSetUser"]),
    async onSubmit(event) {
      this.show_overlay = true;
      event.preventDefault();

      if (!this.isValid()) {
        this.$notifications.addNotification({
          message: "Os dados do formulário são inválidos",
          type: "danger",
        });
      } else {
        try {
          let user = JSON.parse(JSON.stringify(this.user));
          user.pessoa_fisica.imagem = this.imagem ? this.imagem : null;
          delete user.roles;

          let response = await this.ActionSaveProfile(user);
          this.ActionSetUser(response);
          this.$refs.form_profile_senha.alterar_senha = false;

          this.$notifications.addNotification({
            message: "Registro salvo com sucesso",
            type: "success",
          });
        } catch (error) {
          let error_message = "Erro ao salvar";
          this.$notifications.addNotification({
            message: error_message,
            icon: "exclamation-triangle",
            type: "danger",
          });
        }
      }

      this.show_overlay = false;
    },
    isValid() {
      this.validations.form_profile = this.$refs.form_profile.isValid();

      this.validations.form_profile_contatos =
        this.$refs.form_profile_contatos.isValid();

      this.validations.form_profile_senha =
        this.$refs.form_profile_senha.isValid();

      return Object.values(this.validations).every(Boolean);
    },
    loadData(id) {
      this.$router.push({ name: "users_edit", params: { id: id } });
    },
  },
  watch: {
    imagem: {
      deep: true,
      handler: function (value) {
        this.user.pessoa_fisica.imagem_id = value.id;
      },
    },
  },
  async created() {
    this.ActionNewUser();
    this.imagem = this.pessoa_fisica.imagem ? this.pessoa_fisica.imagem : {};
  },
};
</script>

<style lang="scss">
.image-profile {
  display: flex;
  justify-content: center;
  margin-top: -50px;

  .image-profile-bg {
    width: 100px;
    height: 100px;
    background-image: url("~assets/no-user-image.png");
    background-position: center;
    background-repeat: no-repeat;
    background-size: auto 100px;
    border-radius: 50%;
  }

  .custom-file {
    opacity: 0;

    .custom-file-label {
      width: 100px;
      height: 100px;
      border: 1px solid red;
    }
  }
}
</style>
